/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Adm_Where_SpaceInputs */

const en_adm_where_space = /** @type {(inputs: Adm_Where_SpaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`the space ${i?.name}`)
};

const de_adm_where_space = /** @type {(inputs: Adm_Where_SpaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`den Bereich ${i?.name}`)
};

/**
* | output |
* | --- |
* | "the space {name}" |
*
* @param {Adm_Where_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_where_space = /** @type {((inputs: Adm_Where_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Where_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_where_space(inputs)
	return en_adm_where_space(inputs)
});